import { useEffect, useState } from 'react';
import {
  PossibleCompetitorBidding,
  getPossibleCompetitorCompany,
  peekPossibleCompetitorCompany,
} from 'services/actions/ai_management_possible_competitors';

export function usePossibleCompetitorCompanyBiddings(
  biddingId: number | null,
  item: string,
  cnpj: string,
  period: number,
) {
  const peek = () =>
    biddingId ? peekPossibleCompetitorCompany(biddingId, item, cnpj, period) : undefined;
  const [biddings, setBiddings] = useState<PossibleCompetitorBidding[]>(
    () => peek()?.data.licitacoes ?? [],
  );
  const [loading, setLoading] = useState(() => !peek());
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!biddingId) {
      setLoading(false);
      setError(true);
      return undefined;
    }

    const hit = peek();
    if (hit) {
      setBiddings(hit.data.licitacoes ?? []);
      setLoading(false);
      setError(false);
      return undefined;
    }

    let active = true;
    setLoading(true);
    setError(false);

    getPossibleCompetitorCompany(biddingId, item, cnpj, period)
      .then(({ data }) => {
        if (!active) return;
        setBiddings(data.licitacoes ?? []);
        setLoading(false);
      })
      .catch(() => {
        if (!active) return;
        setError(true);
        setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [biddingId, item, cnpj, period]);

  return { biddings, loading, error };
}
